export default __webpack_public_path__ + "static/media/12.16c782a9.png";